<template>
    <dd v-if="question.video">
        <p v-html="question.answer" class="text-base text-gray-500">
        </p>
        <iframe style="margin: auto;" :src="question.video" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
    </dd>
    <dd v-else class="mt-2 pr-12">
        <p v-html="question.answer" class="text-base text-gray-500">
        </p>
    </dd>
</template>

<script>
export default {
    name: "FAQItemAnswer",
    props: ['question'],

}
</script>

<style scoped>

</style>
